import {
  DialogTitle as MuiDialogTitle,
  Typography,
  IconButton,
  Box,
} from '@mui/material';
import { Close } from '@mui/icons-material';

export function DialogTitle(props) {
  const {
    title,
    titleIcon: TitleIcon,
    subTitle,
    onClose,
    details,
    sx,
    ...passThroughProps
  } = props;
  return (
    <MuiDialogTitle sx={{ ...sx, py: 0, pr: 1 }} component="div">
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          py: 1,
          pr: 0.5,
        }}
        {...passThroughProps}
      >
        {TitleIcon ? (
          <TitleIcon
            sx={{
              color: '#6A6D69',
              bgcolor: '#E7EDE4',
              p: 1,
              mr: 1,
              fontSize: '2.5rem',
              borderRadius: '50%',
            }}
          />
        ) : null}
        <Typography
          variant="h6"
          sx={{ display: 'inline-block', lineHeight: '40px' }}
        >
          {title}
        </Typography>
        <Box sx={{ flex: 1 }} />
        {details}
        <IconButton title="Close" onClick={onClose}>
          <Close />
        </IconButton>
      </Box>
      {subTitle ? <Typography variant="body1">{subTitle}</Typography> : null}
    </MuiDialogTitle>
  );
}
